import moment from 'moment';
import { uuid } from 'vue-uuid';
import NodeRSA from 'node-rsa';
import { generate } from 'referral-codes';

function getRandomCode() {
    const code = generate({  length: 8,
        count: 1, });
    if (code.length > 0){
        return code[0].toUpperCase();
    }
    return 'unknown';
}

function getUUId(){
    return uuid.v4();
}

function formatDate(date) {
    return moment(date)
        .format('YYYY-MM-DD');
}

function formatDateTime(date) {
    return moment(date)
        .format('YYYY-MM-DD HH:mm:ss');
}

function getCurrentDate() {
    const now = new Date();
    return moment(now)
        .format('YYYY-MM-DD');
}

function RSAEncrypted(keyData, text) {
    console.log(`RSAEncrypted == ${keyData}`);
    const key = new NodeRSA(keyData);
    const encrypted = key.encrypt(text, 'base64');
    console.log(encrypted);
    return encrypted;
}

function addDayFormat(add, format){
    const now = new Date();
    const utc = now.getTime() + (now.getTimezoneOffset() * 60000);
    const offset = 8;
    const currentTime = new Date(utc + (3600000 * offset));
    currentTime.setDate(currentTime.getDate() + add);
    return moment(currentTime).format(format);
}

export {
    getUUId,
    formatDate,
    RSAEncrypted,
    getCurrentDate,
    addDayFormat,
    formatDateTime,
    getRandomCode
}
